module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-4-55ace85890aa7c442d6dd761f0df5a99.webp";